<template>
  <div class="child-container">
    <div>
      <div class="type">
        <div>
          <div class="activity-header">
            <span>Questions asked by you</span>
          </div>
          <Asked></Asked>
        </div>
        <div>
          <div class="activity-header">
            <span>Questions answered by you</span>
          </div>
          <Answered />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Asked from "./PatientQAAsked"
import Answered from "./PatientQAAnswered"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  components: {
    Asked,
    Answered,
  },
  data() {
    return {
      updates: [],
      pagination: null,
      currentPage: 1,
      limit: 10,
      showNo: true,
      tabs: { ask: true, ans: false },
      activeTab: "ask",
      currentTabComponent: "Asked",
    }
  },

  created() {
    // this.fetch()
  },

  mounted() {
    this.tabs.ask = true
    this.activeTab = "ask"
  },

  methods: {
    /**
     * Change tab based on user selection
     *
     * @param {Object} event
     */
    changeTab(event) {
      if (this.tabs.hasOwnProperty(event.target.id)) {
        this.tabs[this.activeTab] = false
        this.tabs[event.target.id] = true
        this.activeTab = event.target.id
        event.target.id === "ask" ? (this.tabs.ask = true) : (this.tabs.ans = true)
      }
    },

    pushToHome() {
      this.$router.push({ name: "ActivityHome" })
    },
    fetch(append = false) {
      this.showNo = true
      UserRepository.getUpdates(this.currentPage, this.limit, this.authUser.user, this.currentCircle.id)
        .then(res => {
          if (append) {
            this.updates.push(...res.data.data.data)
          } else {
            if (res.data) {
              console.log(res.data)
              this.updates = res.data.data ? (res.data.data.data ? res.data.data.data : []) : []
              console.log(this.updates, "updates")
              this.showNo = false
              this.pagination = res.data.data.paginator
            }
          }
          this.currentPage += 1
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 426px) {
  .child-container {
    width: 100% !important;
  }
}

.type {
  display: flex;
  flex-direction: column;
  gap: 80px;
}
.child-container {
  width: 790px;
  // height: 2716px;
}
.activity-header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/QA/PatientQA.vue